import(/* webpackMode: "eager" */ "/var/jenkins_home/workspace/firefly-community-prod/frontend-web/src/app/[lang]/error.tsx");
